import { render } from "./AdminChatsView.vue?vue&type=template&id=022be652&scoped=true&ts=true"
import script from "./AdminChatsView.vue?vue&type=script&lang=ts"
export * from "./AdminChatsView.vue?vue&type=script&lang=ts"

import "./AdminChatsView.vue?vue&type=style&index=0&id=022be652&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022be652"]])

export default __exports__